// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"81283417","167":"216e0efb","262":"a45c35e1","542":"991cf13a"}[chunkId] + ".chunk.js";
};